import { types } from "../actions/empInbox";

const initialState = {
  businessServices: [],
  tenantId: "",
  count: 0,
  officerRole: [],
};

const empInboxReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_DETAILS:
      return {
        ...state,
        businessServices: action.payload.businessServices,
        tenantId: action.payload.tenantId,
        count: action.payload.count,
        officerRole: action.payload.officerRole,
      };
    default:
      return state;
  }
};

export default empInboxReducer;
